import React, { useEffect, useState } from 'react';
import { Button } from 'reactstrap';

//Context
import { useAuth } from '../../../../context/auth';

//Components
import TabelaListagem from '../../../../components/TabelaListagem/TabelaListagem';
import RoteiroFiscalizacaoStepper from './components/RoterioFiscalizacaoStepper';

//Constants
import { actionsTable } from '../../../../constants/MaterialTable';

//Helpers
import { showMessage } from '../../../../helpers/message';

//API
import roteiroDeFiscalizacao_api from '../../../../api/roteiroDeFiscalizacao_api';

export default function RoterioFiscalizacao({ permissoes }) {
  const { setLoading } = useAuth();

  //Estado de controle da lista de tipo de requerimento
  const [roteiroFiscalizacoes, setRoteiroFiscalizacoes] = useState([]);

  //State de controle de exibição da tela de cadastro
  const [cadastro, setCadastro] = useState(false);

  //State de controle para edição de tipo de requerimento
  const [roteiroFiscalizacao_id, setRoteiroFiscalizacao_id] = useState(null);

  //Variavel de controle de edição da tela
  const editavel = permissoes.filter(permissao => permissao.acao == "Editar").length > 0;

  //Função de configuração de visualização do tipo de requerimento
  const visualizar = (roteiroFiscalizacao) => {
    setRoteiroFiscalizacao_id(roteiroFiscalizacao.id);
  }

  //Cabeçalhos que a tabela terá
  const headers = [
    { value: "Identificação", objectValue: "identificacao", align: "left" },
    { value: "Status", objectValue: "status", align: "left" }
  ]

  //Ações que a tabela terá
  const actions = [actionsTable.visualizar(visualizar)];

  const loadRoteiroFiscalizacao = () => {
    setLoading(true);
    roteiroDeFiscalizacao_api.getList()
      .then(response => {
        setRoteiroFiscalizacoes(response.data);
      })
      .catch(ex => showMessage("Aviso", ex.message, "error", null))
      .finally(() => setLoading(false))
  }
  useEffect(() => {
    loadRoteiroFiscalizacao();
  }, []);

  const handleVoltar = () => {
    setCadastro(false);
    setRoteiroFiscalizacao_id(null);
    loadRoteiroFiscalizacao();
  }

  if (cadastro || roteiroFiscalizacao_id) {
    return <RoteiroFiscalizacaoStepper
      id={roteiroFiscalizacao_id}
      handleVoltar={handleVoltar}
      editavel={editavel}
    />
  }

  return <>
    <div className='d-flex align-items-center justify-content-between mb-4'>
      <h4 className='text-secondary m-0'>Fluxo Administrativo</h4>
      <Button color='success' onClick={() => { setCadastro(true) }}>+ Cadastrar</Button>
    </div >
    <TabelaListagem
      actions={actions}
      title={"Lista de Roteiros de Fiscalização"}
      options={{ print: false, search: true, pagination: true }}
      headers={headers}
      items={roteiroFiscalizacoes} />
  </>;
}
